export default __webpack_public_path__ + "static/media/qr-code-bg.d446e9b1.png";